var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wrap" }, [
      _c("h1", [_vm._v("客户管家运单回收规则说明")]),
      _c("h3", [_vm._v("1、各类型运单回收规则：")]),
      _c("img", {
        staticClass: "imgSize",
        attrs: {
          src: require("@/assets/images/common/recycle.png"),
          alt: "回收规则",
        },
      }),
      _c("h3", [_vm._v("2、各电商平台运单使用详情：")]),
      _c("p", { staticClass: "ptext" }, [
        _vm._v("淘宝："),
        _c(
          "a",
          { attrs: { href: "https://waybill.wuliu.taobao.com/recycle.htm" } },
          [_vm._v("https://waybill.wuliu.taobao.com/recycle.htm")]
        ),
      ]),
      _c("p", { staticClass: "ptext" }, [
        _vm._v("拼多多："),
        _c(
          "a",
          { attrs: { href: "https://mms.pinduoduo.com/logistics/detail" } },
          [_vm._v("https://mms.pinduoduo.com/logistics/detail")]
        ),
      ]),
      _c("p", { staticClass: "ptext" }, [
        _vm._v("抖音："),
        _c(
          "a",
          {
            attrs: {
              href: "https://fxg.jinritemai.com/ffa/mexpress/eBill/detail/list",
            },
          },
          [_vm._v("https://fxg.jinritemai.com/ffa/mexpress/eBill/detail/list")]
        ),
      ]),
      _c("p", { staticClass: "ptext" }, [
        _vm._v("快手："),
        _c(
          "a",
          {
            attrs: {
              href: "https://s.kwaixiaodian.com/zone/supply/express/electronic-sheet",
            },
          },
          [
            _vm._v(
              "https://s.kwaixiaodian.com/zone/supply/express/electronic-sheet"
            ),
          ]
        ),
      ]),
      _c("p", { staticClass: "ptext" }, [
        _vm._v("京东："),
        _c(
          "a",
          {
            attrs: { href: "https://delivery.shop.jd.com/eps/waybillMonitor" },
          },
          [_vm._v("https://delivery.shop.jd.com/eps/waybillMonitor")]
        ),
      ]),
      _c("h3", [_vm._v("3、大客户权益店铺的圆通电商面单回收说明：")]),
      _c("h4", [_vm._v("次日返是什么？为什么会产生补扣？")]),
      _c("p", { staticClass: "ptext" }, [
        _vm._v(
          " 大客户权益店铺所拉取的圆通面单，操作手动回收后，可享受面单余额次日返还的权益。次日返返还的面单余额由圆通内部系统自动为用户充值，同时，根据电商平台的不同，在15日左右，电商平台会再次将由圆通已为用户充值的余额，再次为用户充值，因此，圆通内部系统会在平台为用户再次充值余额后，会为用户扣除此次由电商平台再次返还的面单余额。 "
        ),
      ]),
      _c("p", { staticClass: "ptext" }, [
        _vm._v(
          " 例：用户手动回收了自身账号下的大客户权益店铺的圆通运单：YT123。此时假设用户成功回收YT123后，YT123运单所属面单账号余额为1。次日，圆通为用户返回了一个余额，此时YT123运单所属面单账号余额为2。15日后，电商平台又再次回收YT123时，会再次为用户充值一个面单余额，此时YT123运单所属面单账号余额为3。圆通系统判断平台再次为用户充值余额时，就会将该余额扣除，成功扣除后，用户YT123运单所属面单账号余额为2。此方法保证了大客户权益店铺可享受次日返还余额的同时，也保证了一个已回收运单只会对应一个面单返还余额。 "
        ),
      ]),
      _c("p", { staticClass: "ptext" }, [
        _c("span", { staticClass: "y-fw-700" }, [_vm._v("说明：")]),
        _vm._v(
          "大客户权益店铺的圆通运单因网络波动等原因，有极小概率会造成电商平台回收成功，但圆通内部系统回收失败，从而造成无法次日返还余额。此种情况，余额将依据相应电商平台自身规则，在15日左右将余额返还至用户面单账号，且不会产生圆通的补扣。 "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }